module.exports = __webpack_public_path__ + "img/en.6dcadf69.svg";